import { useParams } from "react-router";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "@refinedev/react-hook-form";

import { LandingFormValues, landingSchema } from "@modules/landings/validations/landingSchema";
import { useEditLandingMutation } from "@modules/landings/services/mutations";

export function useLandingEditForm() {
  const { id } = useParams();
  const { mutateAsync, isPending } = useEditLandingMutation(id as string);

  const methods = useForm<LandingFormValues>({
    resolver: zodResolver(landingSchema()),
    mode: "onBlur",
  });

  const {
    handleSubmit,
    refineCore: { formLoading },
  } = methods;

  return {
    methods,
    handleSubmit,
    mutateAsync,
    isPending,
    formLoading,
    id,
  };
}
